module.exports = __webpack_public_path__ + "static/media/LI13.50ae763d.jpg";